// extracted by mini-css-extract-plugin
export default {"CloudSut":"CloudSut_CloudSut__WhtNy"};